<template>
      <v-card
        class="mx-auto"
        max-width="1000"
        min-width="300"
      >
        <v-toolbar class="pencil"   :color="ToolColor" dark @click="Loadin();Hide = !Hide">
          <v-toolbar-title>{{ Headline }}</v-toolbar-title>

          <v-toolbar-side-icon color="white darken-1">
            <v-icon v-if="Hide == false" color="orange ligthen-1" >arrow_downward</v-icon>
            <v-icon v-else color="orange ligthen-1">arrow_upward</v-icon>
          </v-toolbar-side-icon>

          <v-spacer></v-spacer>
        </v-toolbar>
  <v-expand-transition>




        <div v-if="Hide">
          <p id="down"> En vissling är en möjlighet för en elev på skolan att anonymt få lufta. Det kan vara förbättringsförslag, något hen är orolig över eller att den ser att någon blir felbehandlad. Eleverna kan vissla in till alla i EHT eller till en utvald person som den känner större förtroende för eller är bäst lämpad i gällande ärende.
   För att möjligöra för eleverna att kunna vissla får skolan dela sin visslingskod, denna står i gröna rutan nedan. Eleven skriver in koden i följande länk och resten löser sig själv.</p>
<div id="down">
<a href="https://app.ehtkollen.se/whistle/">https://app.ehtkollen.se/whistle/ </a>

          <v-btn dark large class="b" color="green ligthen-1" >
            {{schoolCode}}
          </v-btn>
</div>
          <div v-if="whistles.length!=0">
  <div>
    <v-flex justify="center">
            <RemoveWindow   Type="Whistle" :removeItem="removeItem" v-model="dialogDelete"   Headline="Ta bort Visslingen " WarningText="Är du säker på att du vill ta bort denna Vissling från EHTKollen? En vissling som är
              borttagen går inte att återfå."    />

    </v-flex>
                <v-text-field
          v-model="search"
          label="Sök efter vissling"
          class="mx-4"
        ></v-text-field>
    <v-data-table
      :headers="headers"
      :items="whistles"
      item-key="name"
      sort-by="name"
      class="elevation-1"
      :pagination.sync="pagination"
      :search="search"
      show-group-by
    >
      <template v-slot:items="props">
        <td class="text-xs-right">{{ props.item.message }}</td>
      
        <!-- <td class="text-xs-right">
                    <v-btn
            class="mx-2"
            fab
            dark
            small
            @click="openLink(props.item)"
            color="purple ligthen-1"
          >
            <v-icon dark> wysiwyg </v-icon>
          </v-btn>
          </td> -->
       
       

         <td class="text-xs-right">
          {{  props.item.hasOwnProperty('uploadDate') ?    locfun.getDate(
              props.item.uploadDate
            ): 'Ingen data att visa' }}
        </td>


        <td class="text-xs-right" v-if="role!='teacher'">
  <v-btn
            class="mx-2"
            fab
            dark
            small
            @click="
              removeItem = props.item;
              dialogDelete = true;
            "
            color="red ligthen-1"
          >
            <v-icon dark> clear </v-icon>
          </v-btn>
        </td>

      </template>
            <template v-slot:no-results>
        <v-alert :value="true" color="error" icon="warning">
         Det finns inget resultat för din sökning på "{{ search }}". 
        </v-alert>
      </template>
    </v-data-table>
         <div class="text-xs-center pt-2">
      <v-btn color="light-blue darken-1" dark @click="toggleOrder">Ändra sorteringsordning</v-btn>
      <v-btn color="light-blue darken-1" dark @click="nextSort">Sortera på nästa kolumn</v-btn>
    </div>
       
  </div>
        </div>
              <div v-else  class="bellowPen" :class="ToolColor+ ' lighten-3 text-center'">  
    <span class="tt" color="white">Det finns inga Visslingar just nu.</span>
  
    </div>
        </div>
  </v-expand-transition>
      </v-card>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import fun from "../functions";
// import NewProtokoll from "./NewProtokoll";
import RemoveWindow from "../assets/RemoveWindow";
export default {
  name: "Whistle",
  components: {
  RemoveWindow
  },
  props: {
    // content: Array,
    Headline: String,
    ToolColor: String,
    schoolId: String,
    schoolCode: String,
    role: String,
    id: String,
    
  },

  watch: {
  },
  created() {
    this.locfun = new fun();

  },
  computed: {
    // ...mapGetters("ehtmembers", ["membernameandId"]),
    ...mapGetters('whistles', ['whistles','whistlesFetched']),
  },
  methods: {
    ...mapActions('whistles', ['initWhistlesforMe']),

    Loadin()
    {
      //console.log("hej"+ this.whistlesFetched)
    if (this.whistlesFetched==false) {
      //console.log("Fetched");   
      this.initWhistlesforMe({schoolId: this.schoolId, member: this.id})
}  
    },
    toggleOrder () {
        this.pagination.descending = !this.pagination.descending
      },
      nextSort () {
        let index = this.headers.findIndex(h => h.value === this.pagination.sortBy)
        index = (index + 1) % this.headers.length
        index = index === 0 ? index + 1 : index
        this.pagination.sortBy = this.headers[index].value
      },
IsOpen(AP,id)
{
  if (AP.hasOwnProperty('openedLink')) {
    

      let openedTime= AP.openedLink.find(teacher => teacher.id == id);
    if (openedTime==undefined) {
      return "Inte öppnad"
    }
    else
    return "Öppnat "+this.locfun.getDate(openedTime.time)
      }
        return "Inte öppnad"
},

openAccess(Case){
 let Class= this.classes.find(element => element.id == Case.class); 

  this.accessItem.items= [];
// if (Case.accessType=="mentor" ||Case.accessType=="all"  ||Case.accessType=="teacher"  ) {
if (Case.accessType!="spec") {
  Class.mentorIds.forEach(element => {
    
     this.accessItem.items.push({name:element, icon:"mentor", time:this.IsOpen(Case,element)})
  });
}
if (Case.accessType=="all" ||Case.accessType=="teacher") {
  Class.teacherIds.forEach(element => {
     this.accessItem.items.push({name:element, icon:"teacher", time:this.IsOpen(Case,element)})
  });
}
if (Case.accessType=="spec") {
  Case.specAccess.forEach(element => {
     this.accessItem.items.push({name:element
     , time:this.IsOpen(Case,element)})
  });
} 
// // (this.accessItem)
 this.accessItem.name = Case.name;
 this.dialogAccess = true;
},
openLink(item){
  if (this.role=="teacher") {
    if (!item.hasOwnProperty('openedLink')) {
      item.openedLink=[]
    }
   if(undefined==item.openedLink.find(element => element.id == this.id))
   {
    item.openedLink.push({id:this.id,time: Date.now()})
    this.saveAP(item);
   }

  }
          window.open(item.link, "_blank");  
},
    ...mapActions(["showSuccessSnackbar"]),
  },
  data() {
    return {
      
      search: '',
            pagination: {
          sortBy: 'steps[0].starttime'
        },
      removeItem: { name: "temp", id: "temp" },
      accessItem: { name: "temp", id: "temp" },
      dialogDelete: false,
      dialogAccess: false,
      dis: {},
      dialog: false,
      dialogClass: false,
      Class: null,
      Choosen: null,
      Hide: false,
      headers: [
        {
          text: "Vissling",
          align: "start",
          value: "message"
        },
        { text: "Tid", value: "uploadDate", align: "right" },
         { text: "Ta bort", value: "", align: "right" }
      ],
    };
  },
};
</script>

<style scoped>
#down{
  margin-top: 20px;
  margin-right: 10px;
  margin-left: 10px;
}
</style>